import type { StaticEntityType } from "@/config";
import { EmbeddedPreview, usePdfDetails } from "@library/components";
import { CALENDAR_META } from "../constants";
import type { CalendarProps } from "../types";

export const Preview = ({ entity }: { entity: StaticEntityType }) => {
  const { settings } = entity as StaticEntityType<CalendarProps>;
  const { type } = settings;
  const defaultMeta = CALENDAR_META[type as string] || {};
  const { favicon, domain } = defaultMeta;
  const { shortUrl } = usePdfDetails();
  let {
    metaImage = "",
    metaDescription = "",
    metaTitle = "",
    metaIcon = "",
    metaSiteName = "",
    metaDomain = "",
    code,
  } = settings;

  let src = code;
  if (!metaTitle) metaTitle = settings.code;
  if (!metaIcon && favicon) metaIcon = favicon;
  if (!metaImage && favicon) metaImage = favicon;
  if (!metaDomain && domain) metaDomain = domain;

  if (type === "custom") {
    metaTitle = "HTML Element";
    metaDescription = "Custom HTML Element";
    metaDomain = "Code";
    if (shortUrl) src = shortUrl;
  }
  return (
    <EmbeddedPreview
      payload={{
        metaTitle,
        metaDescription,
        metaIcon,
        metaSiteName,
        metaDomain,
        metaImage,
        src,
      }}
      isVisible={true}
    />
  );
};
